'use string'

import {
    createElements,
    enableSwitcherBtns,
    findSelectionAndCrmData, flatClick, moveAroundTheFloors,
    numberWithCommas, rotation_to_flat, userPrevent
} from "../../../functions";
import { CardTypes, ViewMode } from '../../../common';
import {Buildings, cardsData, isMobile, projectMode, settingsData} from '../../../settings';
import {
    addFavoritesBlock,
} from "../cardsFunctions";
import {moveElements, rightNavMenuZIndexChange} from "../../navigation/right-nav-bar";
import {
    closeUnitCardAnimation,
    createUnitCardAnimation, dragUnitCard, fadeInUnitCardAnimation,
    openAndCloseMobileOptionsCard,
    openAndCloseMobileUnitCard
} from "../cardsAnimation";
import {addApplyNow, openOptionsCard} from "../optionsCards";
import { changeLangToCurrent, getCurrentLang } from '../../language/langSwitcher';
import {dataArrayOfFlat, facingDictionary} from "../cardsConfig";
import {
    changeActiveCardWhenBuildingClick,
    mobileHandleSearch,
    searchGetResults,
    searchResizeCanvas, toggleResultsList,
} from '../../search/search';
import {hideTooltip} from "../../flatTooltip/flatTooltip";
import {isOrbitControlsEnabled} from "../../controls/orbitControls";
import {bombButtonInitActionHandler} from "../../controls/destroyBuilding";
import { canvasResize, renderUpdateValuesOnDemand } from '../../../app';
import {SwipeScript} from "../../controls/swipe";
import {UnitCardClass} from "./UnitCardClass";
import {selectionBoxesSetStatusColor} from "../../threejs/raycast";
import {createCompareCardsButton} from "../../navigation/compareButton";
import {setLordIcon} from "../../../lordicon";
import { Amenities } from '../../amenities/Amenities';
import { analytics } from '../../analytics/analytics';

export function createUnitCard(data) {

    const prevCard = UnitCardClass.findCard();

    if (prevCard?.html && cardsData.multiplyCards) {
        prevCard.html.classList.remove('active');
        prevCard.html.classList.add('non-active');
    }

    let card = createElements('div', [`${CardTypes.Unit}-card`, 'non-canvas'], document.body, 'beforeend', {
        data: 'data-engineId',
        value: data.engineId,
    });

    analytics('unit card',data);
    data.setNode(card);
    data.setFunctionsToMultiCards(card);
    data.setFunctionsToMobileCard();
    setDataToUnitCard(card, data);
    data.setFunctionsToWebCard();
    data.setAnimationsToCard();

    if (UnitCardClass.cards.length > 1 && cardsData.multiplyCards) {
        createCompareCardsButton();
        data.setKeyPlanButtonState();
    }

    document.querySelector(':root').style.setProperty('--left-bar-bottom-move', "264px");

    return card;
}

export const updateUnitCard = (data) => {
    let card = UnitCardClass.findCard();

    if (cardsData.multiplyCards) {
        card = UnitCardClass.findCard(false, 'active');

        if (settingsData.buildingDestroyed) {
            data.setKeyPlanButtonState(UnitCardClass.findCard(false, 'non-active').html);
        }
    }
    UnitCardClass.cards = UnitCardClass.cards.filter(cardInst => cardInst.engineId !== card.html.getAttribute('data-engineid'));

    analytics('unit card',data);
    card.html.setAttribute('data-engineId', `${data.engineId}`);
    card.html.innerHTML = '';

    data.setNode(card.html);
    data.setFunctionsToMobileCard();
    setDataToUnitCard(card.html, data);

    data.setFunctionsToWebCard();
    data.setFunctionsToMobileCard();
    data.setFunctionsToMultiCards(card.html);
    fadeInUnitCardAnimation(1, 0.2, card.html);

    return card.html;
}

const setDataToUnitCard = (card, data) => {
    const previewPicBlock = createElements('div', [`${CardTypes.Unit}-card__preview-block`, 'card__preview-block'], card);
    const cardBoxWrapper = createElements('div', [`${CardTypes.Unit}-card__wrapper`, 'card__wrapper'], card);
    !isMobile && createElements('button', [`${CardTypes.Unit}-card__close-btn`, 'non-canvas', 'close-cards-btn', 'icon-close'], card);

    const previewPic = createElements('img', [`${CardTypes.Unit}-card__preview-block_pic`, 'card__preview-block_pic'], previewPicBlock);
    createCardSwitchers(data, card);
    createHeader(data, cardBoxWrapper);
    addInfopointsBlock(data.infoPoints, cardBoxWrapper);
    addPreview2D(data.plans, previewPic);

    addButtons(cardBoxWrapper, data);

    if (config.features.apartments.isFavorite) {
        addFavoritesBlock(data, cardBoxWrapper, CardTypes.Unit);
    }

    !isMobile && addCompareButtonToUnitCard(data.status === "Available" ? cardBoxWrapper : card);

    clickToPreview2D(previewPicBlock, data);

    disableArrowButtons();

    data.html = card;
}

/**
 * HEADER
 */

export const createHeader = (...props) => {
    const [data, cardBoxWrapper, resize, position = 'afterbegin'] = props;

    const cardBoxHeader = createElements('div', [`${CardTypes.Unit}-card__header`, 'card__header', `${settingsData.isConferenceHost && "conference"}`], cardBoxWrapper, position);

    const titleBox = createElements('div', [`${CardTypes.Unit}-card__title-box`, 'card__title-box'], cardBoxHeader);
    const subTitleBox = createElements('div', [`${CardTypes.Unit}-card__subtitle-box`, 'card__subtitle-box'], cardBoxHeader);
    addTitleBlock(data, titleBox);

    // Apply now
    isMobile && addApplyNow(!settingsData.isLandscape ? titleBox : document.querySelector(`.${CardTypes.Unit}-card__data`), resize);

    if (Buildings.getBuildingsInfoLength() > 1)
        addTowerName(subTitleBox);

    addFloor(data.floor, subTitleBox);
    addPriceBlock(data.price, data.status, titleBox);
}

const addTitleBlock = (props, cardBox) => {
    const titleBlock = createElements('h3', [`${CardTypes.Unit}-card__title`, 'card__title'], cardBox);

    const flatName = createElements( 'span', [`${CardTypes.Unit}-card__title-flat-name`, 'language-string', 'card__title-flat-name'], titleBlock,'beforeend',{data: 'data-dictionary', value: `${getPropType(props.propType)}`});
    flatName.innerHTML = `${changeLangToCurrent(getPropType(props.propType))}`;

    const flatNumber = createElements('span', [`${CardTypes.Unit}-card__title-flat-number`, 'card__title-flat-number'], titleBlock);
    flatNumber.innerHTML = props.propNum;
}

export const getPropType = (propType) => {
    switch (propType) {
        case 'Commercial':
            return 'Comm';
        default:
            return 'Apt.';
    }
};

const addFloor = (floorNum, parent) => {
    const towerNameElement = createElements('div', [`${CardTypes.Unit}-card__floor-number`, `card__floor-number`], parent);

    const floorName = createElements('span', ['language-string'], towerNameElement, 'beforeend',{
        data : 'data-dictionary',
        value: 'floor'});
    floorName.innerHTML = changeLangToCurrent('floor');

    const floorNumber = createElements('span', [`${CardTypes.Unit}-card__floor-number_num`], towerNameElement);
    floorNumber.innerHTML = floorNum;
}

const addTowerName = (parent) => {
    // let towerName = buildings_info.find(option => option.isActive).towerName;
    let towerName = Buildings.getActiveBuilding().info.towerName;

    if (Array.isArray(towerName)){
        towerName = towerName.find(el => el.lang === getCurrentLang()).value;
    }

    const regExp = /[a-z\u0590-\u05fe]/gi;
    const towerNameElement = createElements('div', [`${CardTypes.Unit}-card__tower-name`, `card__tower-name`], parent);

    const isStringName = regExp.test(towerName);
    if (!isStringName) {
        const towerNumber = createElements('span', [`${CardTypes.Unit}-card__tower-name_title`], towerNameElement);
        const towerTitle = createElements('span', [`${CardTypes.Unit}-card__tower-name_num`, 'language-string'], towerNameElement, 'beforeend', {
            data: 'data-dictionary',
            value: 'building'
        });

        towerNumber.innerHTML = towerName + ' ';
        towerTitle.innerHTML = changeLangToCurrent('building');
    } else {
        towerNameElement.innerHTML = towerName;
    }
}

const addPriceBlock = (salePrice, status, cardBox) => {
    const isPrice = salePrice !== 0 && config.crmProjectSettings.property.settings.displayPrice !== 'hide' || settingsData.isConferenceHost;
    const showPriceButton = config.crmProjectSettings.property.settings.displayPrice === 'button';
    const priceBlock = createElements('div', [`${CardTypes.Unit}-card__price`, 'card__price'], cardBox);
    let currentCard = UnitCardClass.findCard();

    if (cardsData.multiplyCards) {
        currentCard = UnitCardClass.findCard(false, 'active');
    }

    // Create price block when price available
    if (isPrice) {
        const currencyLocal = config.crmProjectSettings.localization.currencyLabel;
        const priceValue = createElements('span', [`${CardTypes.Unit}-card__price-value`, 'card__price-value'], priceBlock);
        const priceCurrency = createElements('span', [`${CardTypes.Unit}-card__price-currency`, 'card__price-currency', 'language-string'], priceBlock, 'beforeend',{
            data : 'data-dictionary',
            value: currencyLocal});

        priceCurrency.innerHTML = changeLangToCurrent(currencyLocal);

        if (showPriceButton && object.status === "Available" && isPrice) {
            addShowPriceBtn(priceBlock, priceValue, priceCurrency);
        }

        if (status === "Available" && salePrice !== 0) {
            priceValue.innerHTML = numberWithCommas(Math.floor(salePrice));
        }
    }

    // Create price block for sold flat
    if (status !== "Available") {
        currentCard.html.classList.add('unavailable');
        priceBlock.setAttribute('data-dictionary', status);
        priceBlock.classList.add('language-string');
        priceBlock.innerHTML = changeLangToCurrent(status);
        currentCard.html.querySelector(`.${CardTypes.Unit}-card__wrapper`).classList.add('unavailable');
    } else {
        currentCard.html.classList.remove('unavailable');
        currentCard.html.querySelector(`.${CardTypes.Unit}-card__wrapper`).classList.remove('unavailable');
    }
}

const addShowPriceBtn = (priceBlock, priceValue, priceCurrency) => {
    const showPriceButton = createElements('button', [`${CardTypes.Unit}-card__price-show-price-btn`, 'card__price-show-price-btn', 'language-string'], priceBlock, 'beforeend', {data : 'data-dictionary', value: 'show price'});
    showPriceButton.innerHTML = changeLangToCurrent('show price');
    priceValue.classList.add('hide');
    priceCurrency.classList.add('hide');

    showPriceButton.addEventListener('click', () => {
        showPriceButton.classList.toggle('hide');
        priceValue.classList.toggle('hide');
        priceCurrency.classList.toggle('hide');
    })
}

/**
 * INFO-POINTS
 */

const addInfopointsBlock = (...props) => {
    const [infoPoints, cardBox] = props;
    const infoPointsBlock = createElements('div', [`${CardTypes.Unit}-card__info-points`, 'card__info-points'], cardBox);
    infoPointsBlock.addEventListener('click', infoPointsHandler);

    const regExp = /([A-Za-z])\w+/g;
    const measurement = config.localization.area ? config.localization.area : "m2";
    const dictionary = facingDictionary();

    const cardsInfo = dataArrayOfFlat(infoPoints);

    const infoPointsData = cardsInfo.filter(data => {
        if (config.features.apartments.aptCardFieldsCntUnit.indexOf(data.name) !== -1) {
            return data;
        }
    });

    infoPointsData.forEach(data => {

        if (+data.data === 0) return;
        const cardContentBlock = createElements('div', [`${CardTypes.Unit}-card__info-points-block`, 'card__info-points-block'], infoPointsBlock);
        const cardContentWrapper = createElements('div', [`${CardTypes.Unit}-card__info-points-wrapper`, 'card__info-points-block-wrapper'], cardContentBlock);
        const cardModelName = createElements('div', [`${CardTypes.Unit}-card__info-points-block_data`, 'card__info-points-block_data'], cardContentWrapper);
        const cardModelNameText = createElements('span', [`${CardTypes.Unit}-card__info-points-block_data_text`, 'card__info-points-block_data_text', 'language-string'], cardModelName, 'beforeend', {
            data: 'data-dictionary',
            value: data.data,
        });
        const contentSubtext = createElements('div', [`${CardTypes.Unit}-card__info-points-block_subtitle`, 'card__info-points-block_subtitle'], cardContentWrapper);

        if (regExp.test(data.data)) {
            cardModelNameText.style.direction = "ltr";
        }

        contentSubtext.innerHTML += `<span class="language-string" data-dictionary="${data.name}">${changeLangToCurrent(data.name)}</span>`;
        if (data.name === 'area') {
            const coma = `<span>,</span>`;
            contentSubtext.innerHTML += coma;
            const measurementTag = createElements('span', ['language-string', 'card__info-points-block_subtitle-measurement'], contentSubtext, 'beforeend', {
                'data': 'data-dictionary',
                'value': measurement
            });
            measurementTag.innerHTML += changeLangToCurrent(measurement);
            measurementTag.classList.add('meters');
        }

        cardModelNameText.innerHTML = changeLangToCurrent(data.data);
        cardModelName.classList.add(data.icon);

        if (data.name === 'exposure') {
            const regExp = /,/g;
            const dataArray = data.data.split(regExp);

            cardModelNameText.remove();

            dataArray.forEach(element => {
                for (let key in dictionary) {
                    if (element === key) {
                        const cardModelNameText = createElements('span', [`${CardTypes.Unit}-card__info-points-block_data_text`, 'card__info-points-block_data_text', 'language-string'], cardModelName, 'beforeend', {
                            data: 'data-dictionary',
                            value: dictionary[key].en + 'Short',
                        });

                        cardModelNameText.innerHTML = changeLangToCurrent(dictionary[key].en + 'Short');
                    }
                }
            });
        }
    });
}

/**
 * PREVIEW
 */

const addPreview2D = (data, pic) => {

    if (!data.preview2D) {

        if (Array.isArray(data.gallery) && data.gallery.length){
            const regExp = /com/g;
            const linkStringsArray = data.gallery[0].split(regExp);
            const linkWithParams = linkStringsArray[0] + 'com/cdn-cgi/image/width=272,quality=75' + linkStringsArray[1];
            pic.setAttribute('src',linkWithParams);
        } else {
            pic.setAttribute('src', 'img/holder.jpg');
        }

        return;
    }

    const regExp = /com/g;
    const linkStringsArray = data.preview2D.split(regExp);
    const linkWithParams = linkStringsArray[0] + 'com/cdn-cgi/image/width=272,quality=75' + linkStringsArray[1];
    pic.setAttribute('src', linkWithParams);
}

const clickToPreview2D = (previewBlock, data) => {
    const accessToEnter = !cardsData.cardMode.isUnavailable ? true : config.crmProjectSettings.property.settings.enterNotForSale;

    if (!accessToEnter) return;

    const icon = data.plans.tours360 ? 'icon-360' : 'icon-plan-type';
    previewBlock.classList.add(icon);

    previewBlock.addEventListener('click', previewClickHandler);
}

/**
 * BUTTONS
 */

const addButtons = (cardBox, data) => {
    const buttonBlock = createElements('div', [`${CardTypes.Unit}-card__button`, 'card__button'], cardBox);
    const iconKeyPlan = settingsData.buildingDestroyed ? 'icon-right' : 'icon-floorplan';
    const keyPlanButtonValue = settingsData.buildingDestroyed ? 'Back' : 'Key plan';
    let iconFloorPlan = data.plans.tours360 ? 'icon-360' : 'icon-plan-type';
    const accessToEnter = !cardsData.cardMode.isUnavailable ? true : config.crmProjectSettings.property.settings.enterNotForSale;

    const keyPlanButton = createElements('button', [`${CardTypes.Unit}-card__button-key-plan`, iconKeyPlan, 'language-string', 'cards-buttons', 'button'], buttonBlock, 'beforeend', {
        data: 'data-dictionary',
        value: keyPlanButtonValue
    });
    keyPlanButton.innerHTML = changeLangToCurrent(keyPlanButtonValue);
    keyPlanButton.addEventListener('click', keyPlanHandlerThrottling);

    if (accessToEnter) {
        const floorPlanButton = createElements('button', [`${CardTypes.Unit}-card__button-floor-plan`, iconFloorPlan, 'language-string', 'cards-buttons', 'button'], buttonBlock, 'beforeend',
            {data: 'data-dictionary', value: 'Explore'});
        floorPlanButton.innerHTML = changeLangToCurrent("Explore");
        floorPlanButton.addEventListener('click', floorPlanHandler);
    }

}

export const addCompareButtonToUnitCard = (cardBox) => {
    const button = createElements('button', [`${CardTypes.Unit}-card__compare-btn`, 'button'], cardBox);
    setLordIcon('compare', button, {
        trigger: 'loop',
        delay: 30000,
        stroke: 90
    });
    if (cardsData.multiplyCards) {
        button.classList.add('active');
    }

    button.addEventListener('click', compareBtnUnitCardHandler, {
        capture: true
    });

}

/**
 * SWITCH CARDS
 */

const createCardSwitchers = (object, cardBox) => {
    const switcherBlock = createElements('div', [`${CardTypes.Unit}-card__switcher-block`, 'card__switcher-block'], cardBox.querySelector(`.${CardTypes.Unit}-card__preview-block`));

    // const activeTower = buildings_info.find(option => option.isActive);
    const activeTower = Buildings.getActiveBuilding();

    const sortingCrm = activeTower.info.crm_data.sort((prev, next) => prev.propNum - next.propNum);

    const prevButton = createElements('button', [`${CardTypes.Unit}-card__switcher-block--prev`, `card__switcher-block--prev`, 'icon-left1'], switcherBlock);
    const nextButton = createElements('button', [`${CardTypes.Unit}-card__switcher-block--next`, `card__switcher-block--next`, 'icon-right1'], switcherBlock);

    if (object.propNum === sortingCrm[0].propNum) {
        prevButton.style.opacity = '0';
        prevButton.style.touchAction = 'none';
    } else if (object.propNum === sortingCrm[sortingCrm.length - 1].propNum) {
        nextButton.style.opacity = '0';
        nextButton.style.touchAction = 'none';
    }

    prevButton.addEventListener('click', switchPrevHandler)
    nextButton.addEventListener('click', switchNextHandler)
}

const switchPrevHandler = (e) => {
    switchHandlerThrottling('prev', e);
}

const switchNextHandler = (e) => {
    switchHandlerThrottling('next', e);
}

let timerSwitch;
function switchHandlerThrottling(action, e) {
    const target = e;
    if (timerSwitch !== null) {
        clearTimeout(timerSwitch);
    }

    timerSwitch = setTimeout(function() {
        switchBetweenCards(action, target);
    }, 250);
}
const switchBetweenCards = (action, e) => {
    if (userPrevent()) return;

    const card = CardTypes.Unit;
    const engineId = e.target.closest(`.${card}-card`).getAttribute('data-engineid');
    const {activeTower, crmDataOfFlat} = findSelectionAndCrmData(engineId);
    const object = crmDataOfFlat;
    settingsData.doubleClick = false;

    if (settingsData.bombBlock) return;
    if (settingsData.buildingDestroyed) return;

    const unitCards = UnitCardClass.cards;

    const sortingCrm = activeTower.info.crm_data.sort((prev, next) => prev.propNum - next.propNum);
    let newObject;

    /**
     * Found flat by propNum
     */

    const currentObject = sortingCrm.find(item => item.propNum === object.propNum).propNum;
    sortingCrm.forEach((flat, index) => {

        const actionIndex = (action === 'prev') ? index - 1 : index + 1;
        const actionIndexMutli = (action === 'prev') ? index - 2 : index + 2;

        if (flat.propNum === currentObject) {
                newObject = sortingCrm[actionIndex];

                if (cardsData.multiplyCards && newObject.engineId) {
                    unitCards.forEach(card => {
                        if (card.html.getAttribute('data-engineid') === newObject.engineId) {
                            newObject = sortingCrm[actionIndexMutli]
                        }
                    })
                }
        }
    })


    if (!newObject) {
        return;
    }

    let newObjectSelection = activeTower.apartments.find(item => item.name === newObject.engineId);

    setActiveClassHandler(e, newObjectSelection);
    flatClick(newObjectSelection);

    if (document.querySelector('.search__container-main')) {
        changeActiveCardWhenBuildingClick(newObjectSelection, true);
    }
}

export const disableArrowButtons = () => {
    const cardBox = UnitCardClass.cards;

    if (cardBox.length > 0) {
        cardBox.forEach(card => {
            const blockButtons = card.html.querySelector(`.${CardTypes.Unit}-card__switcher-block`);

            if (settingsData.buildingDestroyed || cardsData.multiplyCards ) {
                if (!blockButtons.classList.contains('hide')) {
                    blockButtons.classList.add('hide');
                }
            } else {
                if (blockButtons.classList.contains('hide')) {
                    blockButtons.classList.remove('hide');
                }
            }
        })
    }
}

/**
 * HANDLERS
 */

const infoPointsHandler = (e) => {
    const currentCard = e.target.closest(`.${CardTypes.Unit}-card`);
    const {crmDataOfFlat} = findSelectionAndCrmData(currentCard.getAttribute('data-engineid'));
    crmDataOfFlat['custom-field-source'] = 'info-points';

    openOptionsCard(crmDataOfFlat);
};

const floorPlanHandler = (e) => {
    const currentCard = e.target.closest(`.${CardTypes.Unit}-card`);
    const {crmDataOfFlat} = findSelectionAndCrmData(currentCard.getAttribute('data-engineid'));
    crmDataOfFlat['custom-field-source'] = 'floor-plan';

    openOptionsCard(crmDataOfFlat);
};

let timerKeyPlan;
function keyPlanHandlerThrottling(e) {
    if (timerKeyPlan !== null) {
        clearTimeout(timerKeyPlan);
    }

    timerKeyPlan = setTimeout(function() {
        keyPlanHandler(e);
    }, 250);
}

const keyPlanHandler = (e) => {
    const currentCard = e.target.closest(`.${CardTypes.Unit}-card`);
    const button = currentCard.querySelector(`.${CardTypes.Unit}-card__button-key-plan`);
    hideTooltip();
    cardsData.multiplyCards && setActiveClassHandler(e, false);

    if (!isOrbitControlsEnabled() || settingsData.bombBlock) return;

    const {selectedMesh} = findSelectionAndCrmData(currentCard.getAttribute('data-engineid'));
    const floorIndex = selectedMesh.userData.floor;

    enableSwitcherBtns(true);
    toggleResultsList('close');

    /**
     * if one opening card
     */

    if (UnitCardClass.cards.length === 1 && !cardsData.cardMode.isDoubleCard) {
        settingsData.lastClickedFlat = selectedMesh;
        settingsData.currentFloor = floorIndex;

        bombButtonInitActionHandler();

        if (settingsData.buildingDestroyed) {
            changeKeyButtonState(button, currentCard, 'icon-floorplan', 'icon-right', 'Back');
        } else {
            changeKeyButtonState(button, currentCard, 'icon-right', 'icon-floorplan','Key plan');
        }

        /**
         * if two opening card
         */
    } else {

        /**
         * if close one of cards or click on Key-plan button to another opening card
         */

        if (button.classList.contains('icon-floorplan') && settingsData.buildingDestroyed || cardsData.cardMode.isDoubleCard) {

            changeKeyButtonState(button, currentCard, 'icon-floorplan', 'icon-right', 'Back');

            /**
             * Change button icon of nonActive card
             */

            const nonActiveCard = UnitCardClass.findCard(false, 'non-active');
            if (nonActiveCard) {
                const nonActiveCardButton = nonActiveCard.html.querySelector(`.${CardTypes.Unit}-card__button-key-plan`);
                changeKeyButtonState(nonActiveCardButton, nonActiveCard.html, 'icon-right', 'icon-floorplan','Key plan');
            }

            moveAroundTheFloors(selectedMesh.userData.crm_data.engineId);

            /**
             * if click on card with button "Back"
             */
        } else {
            settingsData.lastClickedFlat = selectedMesh;
            settingsData.currentFloor = floorIndex;

            if (settingsData.buildingDestroyed) {
                changeKeyButtonState(button, currentCard, 'icon-right', 'icon-floorplan','Key plan');
            } else {
                changeKeyButtonState(button, currentCard, 'icon-floorplan', 'icon-right', 'Back');
            }
            bombButtonInitActionHandler();
        }
    }
    renderUpdateValuesOnDemand();
    rightNavMenuZIndexChange();
    if (isMobile) moveCardWhenBuildingDestroyed();
}

export function changeKeyButtonState(button, currentCard, previousClass, newClass, innerWord) {
    if (!button) {
        button = currentCard.querySelector(`.${CardTypes.Unit}-card__button-key-plan`);
    }

    button.classList.remove(previousClass)
    button.classList.add(newClass);
    button.innerHTML = changeLangToCurrent(innerWord);
    button.setAttribute('data-dictionary', innerWord);
}

const compareBtnUnitCardHandler = (e) => {
    const target = e.target;
    if (target.classList.contains(`${CardTypes.Unit}-card__compare-btn`)) {

        if (e.target.classList.contains('active')) {
            setActiveClassHandler(e);
            UnitCardClass.deactivateMutliCardsMode(target);
        } else {
            UnitCardClass.activateMutliCardsMode(target);
        }
    }
}

export const closeHandler = (e) => {
    const currentCard = e.target.closest(`.${CardTypes.Unit}-card`)
    const currentCardId = currentCard.getAttribute('data-engineid');

    const instancedCard = UnitCardClass.findCard(currentCardId);

    if (isMobile && settingsData.isLandscape) {
        // instancedCard.closeMobileCard();
        console.log('close')
        UnitCardClass.closeMobileCard();
        if (settingsData.activeViewMode === ViewMode.Cylinder){
            !settingsData.activeModeSwitching && Amenities.show(0);
        }
    } else {
        instancedCard.closeWebOrDesktopCard(currentCard, currentCardId);
        if (settingsData.activeViewMode === ViewMode.Cylinder){
            !settingsData.activeModeSwitching && Amenities.show(0);
        }
    }
}

const previewClickHandler = (e) => {
    e.stopPropagation();

    const currentCard = e.target.closest(`.${CardTypes.Unit}-card`);
    const preview = currentCard.querySelector(`.${CardTypes.Unit}-card__preview-block`);
    const {crmDataOfFlat, selectedMesh} = findSelectionAndCrmData(currentCard.getAttribute('data-engineid'))

    if (e.target === preview) {
        setActiveClassHandler(e);
        openOptionsCard(crmDataOfFlat, config, true);
    } else if (selectedMesh.userData?.customSelection) {
        openOptionsCard();
    }
}

export const setActiveClassHandler = (e, switchObj) => {
    e.preventDefault();
    const unitCardList = UnitCardClass.cards;

    if (!e.target.closest(`.${CardTypes.Unit}-card`)) return;
    const target = e.target.closest(`.${CardTypes.Unit}-card`).getAttribute('data-engineid');

    /**
     * Search toggle active class
     */
    const searchItemPrevious = document.querySelector(`.search__result-item.active-card`);
    const searchItem = document.querySelector(`.search__result-item[data-engineid=${target}]`);
    searchItemPrevious && searchItemPrevious.classList.remove('active-card');
    searchItem && searchItem.classList.add('active-card');

    /**
     * remove active class from all cards
     */
    unitCardList.forEach(card => {
        card.html.classList.remove('active');
        card.html.classList.add('non-active');
    });

    /**
     * if click was from switching of cards, change only active card
     */
    if (switchObj) {
        const {selectedMesh} = findSelectionAndCrmData(target);

        console.log(UnitCardClass.cards.length > 1, !cardsData.multiplyCards)
        if (UnitCardClass.cards.length > 1 || !cardsData.multiplyCards) {
            selectedMesh.userData.isClicked = false;
            selectionBoxesSetStatusColor(selectedMesh, 'hoverOut');
        }

        settingsData.lastClickedFlat = switchObj;
        rotation_to_flat(switchObj);
        switchObj.userData.isClicked = true;
        selectionBoxesSetStatusColor(switchObj, 'click');
        cardsData.multiplyCards && setActiveCard(e.target.closest(`.${CardTypes.Unit}-card`));

        return;
    }

    /**
     * set active class to clicked card
     */
    unitCardList.forEach(card => {
        if (target === card.html.getAttribute('data-engineid')) {

            const {selectedMesh} = findSelectionAndCrmData(target);

            settingsData.lastClickedFlat = selectedMesh;

            cardsData.multiplyCards && setActiveCard(card.html);
        }
    });
}

export const setActiveCard = (card) => {
    card.classList.toggle('non-active');
    card.classList.toggle('active');
}

export const changeUnitCardPosition = () => {

    const param = settingsData.isDesktopMode;
    const unitCard = UnitCardClass.findCard();
    if (param || !unitCard) return;

    const currentDirection = document.querySelector('.aside__container').getAttribute('data-menu-position');
    const id = unitCard.engineId;


    if (isMobile) {
        UnitCardClass.closeMobileCard();
        const {selectedMesh} = findSelectionAndCrmData(id);
        flatClick(selectedMesh);
        selectionBoxesSetStatusColor(selectedMesh, 'click');
        selectedMesh.userData.isClicked = true;
        return;
    }

    function setAndChangeAttributes(fromDirection, toDirection) {
        let position = unitCard.html.style[fromDirection];
        position = (!position) ? unitCard.html.style[toDirection] : position;

        const positionNumber = position.replace('px', '');

        unitCard.html.removeAttribute('style');
        unitCard.html.setAttribute('style', `${toDirection}:${+positionNumber}px`);
    }

    if (unitCard && param !== '1') {
        currentDirection === 'right'
            ? setTimeout(() => setAndChangeAttributes('right', 'left'), 70)
            : setTimeout(() => setAndChangeAttributes('left', 'right'), 70);
    }
}

export const changeCardPositionWhenSearchOpen = () => {
    return;
    const isDesktopMode = settingsData.isDesktopMode;
    const card = UnitCardClass.findCard();
    const search = document.querySelector(`.search__container-main`);

    if (isDesktopMode) return;


    const cardCurrentPosition = card.html.getBoundingClientRect().x;
    if (search) {
        const searchWidth = search.getBoundingClientRect().width;
        const newCardPosition = cardCurrentPosition - searchWidth;
        card.html.style.left = `${newCardPosition}px`;
    } else {
        card.html.style.left = `${window.innerWidth - card.html.getBoundingClientRect().width - 37}px`;
    }
}

/**
 * MOBILE FUNC
 */

export const addSwipeListener = () => {
    const cardBox = UnitCardClass.findCard();
    const accessToEnter = !cardsData.cardMode.isUnavailable ? true : config.crmProjectSettings.property.settings.enterNotForSale;

    SwipeScript(cardBox.html);

    if (!settingsData.isLandscape) {
        accessToEnter && cardBox.html.addEventListener('swiped-up', openAndCloseMobileOptionsCard);
        cardBox.html.addEventListener('swiped-down', () => openAndCloseMobileUnitCard('close'));
    } else if (settingsData.isLandscape && document.querySelector('html').getAttribute('dir') === 'rtl') {
        accessToEnter && cardBox.html.addEventListener('swiped-right', openAndCloseMobileOptionsCard, {once: true});
        cardBox.html.addEventListener('swiped-left', () => openAndCloseMobileUnitCard('rtl-close'), {once: true});
    } else {
        accessToEnter && cardBox.html.addEventListener('swiped-right', () => openAndCloseMobileUnitCard('ltr-close'), {once: true});
        cardBox.html.addEventListener('swiped-left', openAndCloseMobileOptionsCard, {once: true});
    }
}

export const moveCardWhenBuildingDestroyed = () => {
    const card = UnitCardClass.findCard();
    if (!card) return;

    const transform = window.getComputedStyle(card.html).transform;

    if (transform !== 'matrix(1, 0, 0, 1, 0, 0)' && transform !== 'matrix(0.95, 0, 0, 0.95, 0, 0)' && transform !== "none") {
        return;
    }

    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
    const slider = document.querySelector('.fs__main__container');
    let sliderWidth = slider ? slider.getBoundingClientRect().width : document.querySelector('.right-nav-bar').getBoundingClientRect().width

    const urlParam = settingsData.isDesktopMode;

    if (urlParam) return;

    if (isMobile) {
        if (settingsData.buildingDestroyed && !rtl && settingsData.isLandscape) {
            card.html.style.right = `${sliderWidth}px`;
            card.html.style.transition = 'right .2s ease';
            card.html.style.left = 'initial';
        } else if (settingsData.buildingDestroyed && rtl && settingsData.isLandscape) {
            card.html.style.right = 'initial';
            card.html.style.left = `${sliderWidth}px`;
            card.html.style.transition = 'left .2s ease';
        } else if (!settingsData.buildingDestroyed && settingsData.isLandscape) {
            if (rtl) {
                card.html.style.left = `0`;
            } else {
                card.html.style.right = `0`;
            }
        }
        return;
    }

    const buildingDestroyed = settingsData.buildingDestroyed;
    const fsContainer = document.querySelector('.fs__main__container');
    const navBarContainer = document.querySelector('.right-nav-bar');
    const menu = document.querySelector('.aside__container');
    const menuPosition = menu.getAttribute('data-menu-position');
    const direction = (rtl || menuPosition === 'right') ? 'left' : 'right';

    let cardPosition, offsetWidth;

    let currentCardPosition = card.html.style[direction];
    currentCardPosition = currentCardPosition.replace('px', '');


    if (urlParam === '1') {
        offsetWidth = navBarContainer.offsetLeft - navBarContainer.getBoundingClientRect().width - card.html.getBoundingClientRect().width - 20;
    } else {
        offsetWidth = rtl ? navBarContainer.offsetLeft : (window.innerWidth - navBarContainer.offsetLeft) / 2;
    }

    if (buildingDestroyed && fsContainer) {
        cardPosition = +currentCardPosition + navBarContainer.clientWidth + offsetWidth;
    } else {
        cardPosition = +currentCardPosition - navBarContainer.clientWidth - offsetWidth;
        if (urlParam === '1') {
            cardPosition = +currentCardPosition + navBarContainer.clientWidth;
        }
    }

    card.html.setAttribute('style', `${!settingsData.isDesktopMode ? 'transform: scale(0.95);' : 'transform: scale(1);'} ${direction}:${cardPosition}px`);
}

export const removeUnitCardListeners = (currentCard) => {
    const floorPlan = currentCard.querySelector(`.${CardTypes.Unit}-card__button-floor-plan`);
    const keyPlan = currentCard.querySelector(`.${CardTypes.Unit}-card__button-key-plan`);
    const preview = currentCard.querySelector(`.${CardTypes.Unit}-card__preview-block`);
    const prevButton = currentCard.querySelector(`.${CardTypes.Unit}-card__switcher-block--prev`);
    const nextButton = currentCard.querySelector(`.${CardTypes.Unit}-card__switcher-block--next`);
    const closeButton = currentCard.querySelector(`.${CardTypes.Unit}-card__close-btn`);
    const compareButton = currentCard.querySelector(`.${CardTypes.Unit}-card__compare-btn`);

    if (!isMobile) {
        closeButton && closeButton.removeEventListener('click', closeHandler);
        compareButton && compareButton.removeEventListener('click', compareBtnUnitCardHandler);

    } else {
        currentCard.removeEventListener('swiped-up', openAndCloseMobileOptionsCard);
        currentCard.removeEventListener('swiped-right', openAndCloseMobileOptionsCard);
        currentCard.removeEventListener('swiped-left', openAndCloseMobileOptionsCard);
    }

    floorPlan && floorPlan.removeEventListener('click', floorPlanHandler);
    keyPlan && keyPlan.removeEventListener('click', keyPlanHandlerThrottling);
    preview && preview.removeEventListener('click', previewClickHandler);
    prevButton && prevButton.removeEventListener('click', switchPrevHandler);
    nextButton && nextButton.removeEventListener('click', switchNextHandler);
    currentCard.removeEventListener('click', setActiveClassHandler);
}

/**
 * Class methods
 */

export function cardsAnimations() {
    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';

    if (isMobile) {
        if (settingsData.isLandscape) {
            rtl ? openAndCloseMobileUnitCard('rtl-open') : openAndCloseMobileUnitCard('ltr-open');
        } else {
            openAndCloseMobileUnitCard('open')
        }
        return;
    }

    createUnitCardAnimation(this);
    setTimeout(() => dragUnitCard(), 200);
}

export function cardsFunctionsWeb() {
    const card = UnitCardClass.findCard(this.engineId);
    const closeButton = card.html.querySelector(`.${CardTypes.Unit}-card__close-btn`);
    closeButton.addEventListener('click', closeHandler);

    hideTooltip();
}

export function cardsFunctionsMobile() {

    const unitCard = UnitCardClass.findCard();

    if (unitCard) {
        unitCard.html.removeEventListener('swiped-up', openAndCloseMobileOptionsCard);
        unitCard.html.removeEventListener('swiped-right', openAndCloseMobileOptionsCard);
        unitCard.html.removeEventListener('swiped-left', openAndCloseMobileOptionsCard);
    }

    addSwipeListener();
    moveCardWhenBuildingDestroyed();
    // !unitCard && searchResizeCanvas();
    !unitCard && canvasResize();
    rightNavMenuZIndexChange();

    // CLOSE SEARCH
    const searchContainer = document.querySelector('.search__container-main');
    const isMinimized = (searchContainer) ? searchContainer.classList.contains('minimize') : '';
    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';

    const actionType = settingsData.isLandscape
        ? rtl ? 'swiped-left' : 'swiped-left'
        : 'swiped-down';

    !isMinimized && mobileHandleSearch({type: actionType});
}

export function cardsCloseWebDesktop(card, id) {
    let currentCard = card;
    let flatData = findSelectionAndCrmData(id);

    removeUnitCardListeners(currentCard);
    closeUnitCardAnimation(currentCard);

    UnitCardClass.cards = UnitCardClass.cards.filter(card => card.engineId !== currentCard.getAttribute('data-engineid'));

    const activeSearchItemList = document.querySelectorAll('.search__result-item:not(.similar-item).active');
    activeSearchItemList.forEach(elem => {
        if (elem.getAttribute('data-engineid') === currentCard.getAttribute('data-engineid')) {
            elem.classList.remove('active');
            elem.classList.remove('active-card');
        } else {
            elem.classList.add('active-card')
        }
    })

    if (flatData && !projectMode.LiteMode.modeIs('picture')) {
        flatData.selectedMesh.userData.isClicked = false;
        selectionBoxesSetStatusColor(flatData.selectedMesh, 'hoverOut');
    }

    const compareBtn = document.querySelector(`.compare-button`);

    if (compareBtn) {
        compareBtn.remove();
    }

    moveElements();
    searchGetResults();
}

export function cardsCloseMobile() {
    const unitCard = UnitCardClass.findCard();
    removeUnitCardListeners(unitCard.html);
    const activeSearchItem = document.querySelector('.search__result-item:not(.similar-item).active');
    activeSearchItem && activeSearchItem.classList.remove('active');

    const {selectedMesh} = findSelectionAndCrmData(unitCard.engineId)
    unitCard.html.parentNode !== null && document.body.removeChild(unitCard.html);

    UnitCardClass.cards = [];
    selectedMesh.userData.isClicked = false;
    selectionBoxesSetStatusColor(selectedMesh, 'hoverOut');
}

export function multiCardsLogic(card) {
    if (!cardsData.multiplyCards) return;
    card.classList.add('active');

    UnitCardClass.cards.forEach(card => {
        card.html.addEventListener('click', setActiveClassHandler);
    })
}

export function keyButtonState(card) {
    if (!card) {
        card = UnitCardClass.findCard()?.html;
    }
    const buttonKeyPlan = card.querySelector(`.${CardTypes.Unit}-card__button-key-plan`)

    if (buttonKeyPlan.classList.contains('icon-right')) {
        buttonKeyPlan.classList.add('icon-floorplan')
        buttonKeyPlan.classList.remove('icon-right');
        buttonKeyPlan.innerHTML = changeLangToCurrent('Key plan');
        buttonKeyPlan.setAttribute('data-dictionary', 'Key plan');
    }
}

export function closeMultiCards() {
    const cardList = UnitCardClass.cards;

    cardList.forEach(card => {
        closeUnitCardAnimation(card.html, true);

        // HOVER OUT SEARCH

        const activeSearchItemList = document.querySelectorAll('.search__result-item:not(.similar-item).active');
        activeSearchItemList.forEach(elem => {
            if (elem.getAttribute('data-engineid') === card.html.getAttribute('data-engineid')) {
                elem.classList.remove('active');
                elem.classList.remove('active-card');
            } else {
                elem.classList.add('active-card')
            }
        })
    });

    // const activeTower = buildings_info.find(option => option.isActive);
    const activeTower = Buildings.getActiveBuilding();
    activeTower.apartments.forEach(item => {
        item.userData.isClicked = false;
        selectionBoxesSetStatusColor(item, 'hoverOut');
    });

    UnitCardClass.cards = [];

    const compareBtn = document.querySelector(`.compare-button`);

    if (compareBtn) {
        compareBtn.remove();
    }

    moveElements();
}
